import { Label, makeStyles, mergeClasses } from "@fluentui/react-components";
import { ArrowSquareUpRightRegular } from "@fluentui/react-icons";
import { Link } from "react-router-dom";
import { $sky60 } from "../../../../cssjs/colors";
import PageEnum from "../../../../enum/PageEnum";
import { ITimeState } from "../../../../models/common/DateTimeModels";
import { useAppSelector } from "../../../../store/StoreHooks";
import { getAirportCode } from "../../../../store/airport/AirportSelector";
import { CommonHelper } from "../../../../utils/common/CommonHelper";
import TimePicker from "../../../common/form-controls/uncontrolled/date-time/TimePicker";

interface IRollingFilterProps {
  fromRollingtime: ITimeState;
  toRollingtime: ITimeState;
  className?: string;
  allowNegative?: boolean;
  label?: string;
  redirectionText?: boolean;
  type?: string;
  padHour?: boolean;
  padMinute?: boolean;
}

const RollingFilter: React.FC<IRollingFilterProps> = ({
  fromRollingtime,
  toRollingtime,
  className = "",
  label = "",
  allowNegative = true,
  redirectionText = false,
  type = "",
  padHour = false,
  padMinute = false,
}) => {
  const styles = useStyles();
  const displayLabel = label ? label : "Hours";
  const isInTeams = CommonHelper.isInTeams();
  const airport = useAppSelector((state) => getAirportCode(state));
  const rollingLinkContent = isInTeams ? (
    <Link
      to={`/${PageEnum.PageUrl.ApplicationSettings}`}
      style={{ color: `${$sky60}`, textDecoration: "none", fontWeight: 600 }}
    >
      KPIs with custom values ON
      <span style={{ position: "relative", top: "2px", fontSize: "12px" }}>
        <ArrowSquareUpRightRegular />
      </span>
    </Link>
  ) : (
    <Link
      to={`/${
        PageEnum.PageUrl.ApplicationSettings
      }?airport=${encodeURIComponent(airport)}`}
      target="_blank"
      rel="noopener noreferrer"
      style={{ color: `${$sky60}`, textDecoration: "none", fontWeight: 600 }}
    >
      KPIs with custom values ON
      <span style={{ position: "relative", top: "2px", fontSize: "12px" }}>
        <ArrowSquareUpRightRegular />
      </span>
    </Link>
  );

  return (
    <>
      <section
        className={mergeClasses(styles.container, className)}
        data-testid="rolling-filter-option"
      >
        <div>
          <Label className={styles.label}>{`From ${displayLabel}`}</Label>
          <TimePicker
            rollingtime={fromRollingtime}
            className={styles.timePickerContainer}
            allowNegative={allowNegative}
            padHour={padHour}
            padMinute={padMinute}
          />
        </div>
        {type !== "kpiConfig" ? (
          <div>
            <Label className={styles.label}>{`To ${displayLabel}`}</Label>
            <TimePicker
              rollingtime={toRollingtime}
              className={styles.timePickerContainer}
              allowNegative={allowNegative}
              padHour={padHour}
              padMinute={padMinute}
            />
          </div>
        ) : (
          <span style={{ top: "14px", position: "relative" }}>
            <Label className={styles.label}>{`To Now`}</Label>
          </span>
        )}
      </section>
      {redirectionText && (
        <div>
          <Label className={styles.label}>Does not apply to </Label>
          {rollingLinkContent}
        </div>
      )}
    </>
  );
};

export default RollingFilter;

const useStyles = makeStyles({
  label: {
    fontSize: "14px",
    fontWeight: "500",
    paddingBottom: "10px",
  },
  container: {
    display: "flex",
    padding: "20px 10px",
    alignItems: "center",
    gap: "30px",
  },

  timePickerContainer: {
    boxShadow: "1px 2px 4px 1px rgba(0, 0, 0, 0.25)",
    marginTop: "10px",
  },
});
